"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToInvalidFormControl = exports.formatOptions = exports.validateCountry = exports.validateInfoEmail = exports.validateEmail = void 0;
const app_1 = require("app");
const embargoCountries = ['RU', 'BY', 'CU', 'IR', 'KP', 'SY'];
const validateEmail = (email) => {
    // tslint:disable-next-line:max-line-length
    // eslint-disable-next-line no-useless-escape
    const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regExp.test(email.toLowerCase());
};
exports.validateEmail = validateEmail;
const validateInfoEmail = (email) => {
    return new RegExp('\\b' + 'info@' + '\\b').test(email);
};
exports.validateInfoEmail = validateInfoEmail;
const validateCountry = (value) => {
    return embargoCountries.includes(value);
};
exports.validateCountry = validateCountry;
const formatOptions = (inputModel, key, value) => inputModel.map(item => {
    return {
        title: item[value],
        value: item[key],
    };
});
exports.formatOptions = formatOptions;
const scrollToInvalidFormControl = (formControl, scrollingItemSelector, includeHeaderHeight = true) => {
    const formControlWrapper = formControl.closest('.form-control-wrapper');
    const elToScrollTo = formControlWrapper || formControl;
    const scrollableContainer = document.querySelector(scrollingItemSelector);
    const header = document.querySelector('header');
    const headerHeight = header && includeHeaderHeight ? header.offsetHeight : 0;
    const scrollableContainerScrollTop = scrollableContainer.scrollTop || document.body.scrollTop;
    const offsetTop = elToScrollTo.getBoundingClientRect().top + scrollableContainerScrollTop;
    const scrollTopValue = offsetTop - headerHeight;
    app_1.scrollService.GoToPosition(app_1.ScrollDirectionEnum.Top, scrollTopValue, app_1.ScrollDurationEnum.Slow, scrollingItemSelector);
};
exports.scrollToInvalidFormControl = scrollToInvalidFormControl;
